import { EventTypes } from "../eventtype.model";

export const KJEventTypes: EventTypes[] = [
  {
    label: "Total User Sessions",
    name: "vv_user_session_start",
    events: ["vv_user_session_start"],
  },
  // {
  //     label: "Total VIP Collection Views",
  //     name: "vip_show_request",
  //     events : [
  //         "vip_show_request",
  //         "vip_show_request_ab_test",
  //         "vip_show_request_banter"
  //     ]
  // },
  // {
  //     label: "Total Category Views",
  //     name: "all_categories_show_request",
  //     events : [
  //         "all_categories_show_request"
  //     ]
  // },
  // {
  //     label: "Total New Arrival Collection Views",
  //     name: "new_arrivals_show_request",
  //     events :[
  //         "new_arrivals_show_request",
  //         "new_arrivals_show_request_ab_test",
  //         "new_arrivals_show_request_banter",
  //     ]
  // },
  {
    label: "Total Virtual Try-On Sessions",
    name: "vv_vto_show_request",
    events: [
      "vv_vto_show_request",
      "vv_vto_show_request_banter",
      "vv_vto_show_request_ab_test",
      "vv_vto_nav_show_request",
      "vv_vto_nav_show_request_ab_test",
      "vv_vto_nav_show_request_banter",
    ],
  },
  {
    label: "Total Pictures Taken",
    name: "vv_vto_image_taken",
    events: [
      "vv_vto_image_taken",
      "vv_vto_image_taken_ab_test",
      "vv_vto_image_taken_banter",
    ],
  },
  {
    label: "Total Social Media Requests",
    name: "curalate_show_request",
    events: [
      "curalate_show_request",
      "curalate_item_product_request",
      "curalate_item_show_request",
      "curalate_show_request_banter",
      "curalate_show_request_ab_test",
      "curalate_nav_show_request",
      "curalate_nav_show_request_ab_test",
      "curalate_nav_show_request_banter",
    ],
  },
  {
    label: "Total Social Media Image Views",
    name: "curalate_item_click",
    events: ["curalate_item_click", "curalate_item_click_ab_test"],
  },
  {
    label: "Total Product Views",
    name: "vv_product_select",
    events: [
      "vv_product_select",
      "vv_product_select_ab_test",
      "vv_product_select_banter",
    ],
  },
  // {
  //     label: "Total Product Shares",
  //     name: "product_info_share_request",
  //     events : [
  //         "product_info_share_request",
  //     ]
  // },
  {
    label: "Total Social Media Item Views",
    name: "curalate_product_item_click",
    events: [
      "curalate_product_item_click",
      "curalate_product_item_click_ab_test",
    ],
  },
  // {
  //     label: "Average Session Time",
  //     name: "vv_user_session_end",
  //     events : [
  //         "vv_user_session_end"
  //     ]
  // }
];

export const SignageEventTypes: EventTypes[] = [
  {
    label: "Total User Sessions",
    name: "vv_session_start",
    events: ["vv_session_start"],
  },

  {
    label: "Total Social Media Requests",
    name: "curalate_show_request",
    events: ["curalate_show_request"],
  },
  {
    label: "Total Social Media Image Views",
    name: "curalate_item_show_request",
    events: ["curalate_item_show_request"],
  },
  {
    label: "Total Social Media Item Views",
    name: "curalate_item_product_request",
    events: ["curalate_item_product_request"],
  },
  // {
  //     label: "Average Session Time",
  //     name: "vv_session_end",
  //     events : [
  //         "vv_session_end"
  //     ]
  // }
];

export const KJEvents: any = [
  {
    label: "Total User Sessions",
    name: "vv_user_session_start",
  },
  {
    label: "Total VIP Collection Views",
    name: "vip_show_request",
  },
  {
    label: "Total Category Views",
    name: "all_categories_show_request",
  },
  {
    label: "Total New Arrival Collection Views",
    name: "new_arrivals_show_request",
  },
  {
    label: "Total Virtual Try-On Sessions",
    name: "vv_vto_show_request",
  },
  {
    label: "Total Pictures Taken",
    name: "vv_vto_image_taken",
  },
  {
    label: "Total Social Media Requests",
    name: "curalate_show_request",
  },
  {
    label: "Total Social Media Image Views",
    name: "curalate_item_show_request",
  },
  {
    label: "Total Product Views",
    name: "vv_product_select",
  },
  {
    label: "Total Product Shares",
    name: "product_info_share_request",
  },
  {
    label: "Total Social Media Item Views",
    name: "curalate_item_product_request",
  },
];

export const KJProductData = [
  {
    query: `SELECT param2.value.string_value AS keyname, count(1) AS value FROM
        \`kay-cms-prod.analytics_268258331.events_*\`,
        UNNEST(event_params) AS param1, UNNEST(event_params) AS param2 WHERE param1.key = 'vv_store_name' and param2.key = 'vv_screen_name' and event_name = 'vv_product_select' and app_info.id = 'com.perfect365.mb2' and param1.value.string_value not in ('Kay - VV Test Lab') `,
    label: "Product Select by Screen Name",
    headers: [
      { label: "Screen Name", key: "keyname" },
      { label: "Event Count", key: "value" },
    ],
    appendquery: `group by 1 order by value desc`,
  },
  {
    query: `SELECT param2.value.string_value AS keyname, count(1) AS value FROM
        \`kay-cms-prod.analytics_268258331.events_*\`,
        UNNEST(event_params) AS param1, UNNEST(event_params) AS param2 WHERE param1.key = 'vv_store_name' and param2.key = 'vv_user_session_type' and event_name = 'vv_product_select' and app_info.id = 'com.perfect365.mb2' and param1.value.string_value not in ('Kay - VV Test Lab') `,
    label: "Product Select by User Session Type",
    headers: [
      { label: "Screen Name", key: "keyname" },
      { label: "Event Count", key: "value" },
    ],
    appendquery: `group by 1 order by value desc`,
  },
  {
    query: `SELECT param2.value.string_value AS screen_name , param1.value.string_value as product_sku, count(1) AS value
        FROM \`kay-cms-prod.analytics_268258331.events_*\`,
        UNNEST(event_params) AS param1,UNNEST(event_params) AS param3, UNNEST(event_params) AS param2 WHERE (param1.key = 'product_sku' and param2.key = 'screen_name') and event_name = 'product_select_ab_test' and app_info.id = 'com.perfect365.mb2' and (param3.key = 'STORE_NAME') and param3.value.string_value not in ('Kay - VV Test Lab') `,
    label: "Product Select Details",
    headers: [
      { label: "Product SKU", key: "product_sku" },
      { label: "Screen Name", key: "screen_name" },
      { label: "Product Name", key: "productName" },
      { label: "Event Count", key: "value" },
      { label: "Category", key: "category" },
      { label: "Listname", key: "listName" },
      { label: "Price", key: "price" },
      { label: "Value", key: "pricevalue" },
    ],
    fetchapi: true,
    requestheaders: {
      "Content-Type": "application/json",
      "Api-Key": "b304d7bf-4c28-4bfb-a387-2408c2c2de6f",
      "Client-ID": "mb872ca6-7b27-4300-b5a6-5b188712fc19",
    },
    customData: ["productName", "category", "listName", "price"],
    appendquery: `group by 1,2 order by value desc`,
  },
  // {
  //     query : `SELECT param2.value.string_value AS product_name , param1.value.string_value as product_sku, count(1) AS value
  //     FROM \`kay-cms-prod.analytics_268258331.events_*\`,
  //     UNNEST(event_params) AS param1, UNNEST(event_params) AS param2 WHERE (param1.key = 'product_sku' and param2.key = 'product_name') `,
  //     label : 'Product Info Request',
  //     headers: [
  //         { label: "Product SKU", key: "product_sku" },
  //         { label: "Product Name", key: "product_name" },
  //         { label: "Event Count", key: "value" }
  //     ],
  //     appendquery : `group by 1,2 order by value desc`
  // },
  {
    query: `SELECT param1.value.string_value AS storename, param2.value.string_value AS keyname, count(1) AS value FROM 
        \`kay-cms-prod.analytics_268258331.events_*\`,
        UNNEST(event_params) AS param1, UNNEST(event_params) AS param2 WHERE param1.key = 'vv_store_name' and param2.key = 'vv_user_session_type' and event_name = 'vv_user_session_start' and app_info.id = 'com.perfect365.mb2' and param1.value.string_value not in ('Kay - VV Test Lab') `,
    label: "User Session Request",
    headers: [
      { label: "Store Name", key: "storename" },
      { label: "Screen Name", key: "keyname" },
      { label: "Event Count", key: "value" },
    ],
    appendquery: `group by 1,2 order by value desc`,
  },
];

export const KJSignageConfig = [
  {
    query: `SELECT event_timestamp, FORMAT_DATE('%m-%d-%Y', PARSE_DATE('%Y%m%d', event_date)) as date, FORMAT_TIME('%T', TIME(TIMESTAMP_MICROS(event_timestamp))) time,event_name, param1.value.string_value as storename, param2.value.string_value as file 
        FROM \`kay-cms-prod.analytics_268258331.events_*\`,
        UNNEST(event_params) AS param1, UNNEST(event_params) AS param2
        WHERE (event_name = "media_tap" or event_name = "curalate_show_request" )
        AND ( param1.key = "STORE_NAME" AND param2.key = "media_file") and app_info.id='com.virtualvisions.kayeasel' `,
    label: "Kay Summary",
    headers: [
      { label: "US TIME", key: "event_timestamp" },
      { label: "Event Date", key: "date" },
      { label: "Event Time", key: "time" },
      { label: "Event Name", key: "event_name" },
      { label: "Store Name", key: "storename" },
      { label: "File/Session ID", key: "file" },
      { label: "Item Requests", key: "item_requests" },
    ],
    mergedata: true,
    appendquery: `ORDER BY date DESC`,
  },
  {
    query: `SELECT param.value.string_value AS storename,event_name, count(1) as value
        FROM \`kay-cms-prod.analytics_268258331.events_*\`, 
        UNNEST(event_params) AS param WHERE param.key = 'STORE_NAME' and event_name = 'media_tap' and app_info.id='com.virtualvisions.kayeasel' `,
    label: "By Store Name ( param : media_tap )",
    headers: [
      { label: "Store Name", key: "storename" },
      { label: "Event Name", key: "event_name" },
      { label: "Event Count", key: "value" },
    ],
    appendquery: `group by 1,2 order by value desc`,
  },
  {
    query: `SELECT param.value.string_value AS storename, event_name, count(1) as value
        FROM \`kay-cms-prod.analytics_268258331.events_*\`, 
        UNNEST(event_params) AS param WHERE param.key = 'STORE_NAME' and event_name in ('curalate_show_request','curalate_item_product_request','curalate_item_show_request') and app_info.id='com.virtualvisions.kayeasel' `,
    label: "Social Media Sessions By Store",
    headers: [
      { label: "Store Name", key: "storename" },
      { label: "Curalate Events", key: "event_name" },
      { label: "Event Count", key: "value" },
    ],
    appendquery: `group by 1,2 order by value desc`,
  },
  // {
  //     query : `SELECT param.value.string_value AS storename,event_name, count(1) as value
  //     FROM \`kay-cms-prod.analytics_268258331.events_*\`,
  //     UNNEST(event_params) AS param WHERE param.key = 'STORE_NAME' and event_name = 'curalate_show_request' and app_info.id='com.virtualvisions.kayeasel' `,
  //     label : 'By Store Name ( param : curalate_show_request )',
  //     headers: [
  //         { label: "Store Name", key: "storename" },
  //         { label: "Event Name", key: "event_name" },
  //         { label: "Event Count", key: "value" },
  //     ],
  //     appendquery : `group by 1,2 order by value desc`
  // },
  // {
  //     query : `SELECT param.value.string_value AS storename,event_name, count(1) as value
  //     FROM \`kay-cms-prod.analytics_268258331.events_*\`,
  //     UNNEST(event_params) AS param WHERE param.key = 'STORE_NAME' and event_name = 'curalate_item_show_request' and app_info.id='com.virtualvisions.kayeasel' `,
  //     label : 'By Store Name ( param : curalate_item_show_request )',
  //     headers: [
  //         { label: "Store Name", key: "storename" },
  //         { label: "Event Name", key: "event_name" },
  //         { label: "Event Count", key: "value" },
  //     ],
  //     appendquery : `group by 1,2 order by value desc`
  // },
  // {
  //     query : `SELECT param.value.string_value AS storename,event_name, count(1) as value
  //     FROM \`kay-cms-prod.analytics_268258331.events_*\`,
  //     UNNEST(event_params) AS param WHERE param.key = 'STORE_NAME' and event_name = 'curalate_item_product_request' and app_info.id='com.virtualvisions.kayeasel' `,
  //     label : 'By Store Name ( param : curalate_item_product_request )',
  //     headers: [
  //         { label: "Store Name", key: "storename" },
  //         { label: "Event Name", key: "event_name" },
  //         { label: "Event Count", key: "value" },
  //     ],
  //     appendquery : `group by 1,2 order by value desc`
  // },
  // {
  //     query : `SELECT event_name, count(1) as value
  //     FROM \`kay-cms-prod.analytics_268258331.events_*\`,
  //     UNNEST(event_params) AS param WHERE param.key = 'STORE_NAME' and event_name in ('curalate_show_request','curalate_item_product_request','curalate_item_show_request') and app_info.id='com.virtualvisions.kayeasel' `,
  //     label : 'Social Media Sessions',
  //     headers: [
  //         { label: "Curalate Events", key: "event_name" },
  //         { label: "Event Count", key: "value" },
  //     ],
  //     appendquery : `group by 1 order by value desc`
  // },

  {
    query: `SELECT param.value.string_value AS file, COUNT(1) AS value
        FROM \`kay-cms-prod.analytics_268258331.events_*\`,
        UNNEST(event_params) AS param
        WHERE event_name = "media_tap" AND param.key = "media_file" and app_info.id='com.virtualvisions.kayeasel' `,
    label: "Media File Count",
    headers: [
      { label: "Media File", key: "file" },
      { label: "Total Count", key: "value" },
    ],
    appendquery: ` GROUP BY 1 order by value desc`,
  },
  {
    query: `SELECT param.value.string_value AS file, param2.value.string_value As storename,  COUNT(1) AS value
        FROM \`kay-cms-prod.analytics_268258331.events_*\`,
            UNNEST(event_params) AS param, UNNEST(event_params) AS param2
        WHERE event_name = "media_tap" AND param.key = "media_file" AND param2.key = "STORE_NAME" and app_info.id='com.virtualvisions.kayeasel' `,
    label: "Media File Count By Store",
    headers: [
      { label: "Media File", key: "file" },
      { label: "Store Name", key: "storename" },
      { label: "Total Count", key: "value" },
    ],
    appendquery: `group by 1,2 order by value desc`,
  },
];

export const ZalesSignageConfig = [
  {
    query: `SELECT event_timestamp, FORMAT_DATE('%m-%d-%Y', PARSE_DATE('%Y%m%d', event_date)) as date, FORMAT_TIME('%T', TIME(TIMESTAMP_MICROS(event_timestamp))) time,event_name, param1.value.string_value as storename, param2.value.string_value as file 
        FROM \`zales-cms-prod.analytics_205854940.events_*\`,
        UNNEST(event_params) AS param1, UNNEST(event_params) AS param2
        WHERE (event_name = "media_tap" or event_name = "curalate_show_request" )
        AND ( param1.key = "STORE_NAME" AND param2.key = "media_file") `,
    label: "Zales Summary",
    headers: [
      { label: "US TIME", key: "event_timestamp" },
      { label: "Event Date", key: "date" },
      { label: "Event Time", key: "time" },
      { label: "Event Name", key: "event_name" },
      { label: "Store Name", key: "storename" },
      { label: "File/Session ID", key: "file" },
      { label: "Item Requests", key: "item_requests" },
    ],
    mergedata: true,
    appendquery: `ORDER BY date DESC`,
  },
  {
    query: `SELECT param.value.string_value AS storename,event_name, count(1) as value
        FROM \`zales-cms-prod.analytics_205854940.events_*\`,
        UNNEST(event_params) AS param WHERE param.key = 'STORE_NAME' and event_name = 'media_tap' `,
    label: "By Store Name ( param : media_tap )",
    headers: [
      { label: "Store Name", key: "storename" },
      { label: "Event Name", key: "event_name" },
      { label: "Event Count", key: "value" },
    ],
    appendquery: `group by 1,2 order by value desc`,
  },
  {
    query: `SELECT param.value.string_value AS storename, event_name, count(1) as value
        FROM \`zales-cms-prod.analytics_205854940.events_*\`,
        UNNEST(event_params) AS param WHERE param.key = 'STORE_NAME' and event_name in ('curalate_show_request','curalate_item_product_request','curalate_item_show_request') `,
    label: "Social Media Sessions By Store",
    headers: [
      { label: "Store Name", key: "storename" },
      { label: "Curalate Events", key: "event_name" },
      { label: "Event Count", key: "value" },
    ],
    appendquery: `group by 1,2 order by value desc`,
  },
  {
    query: `SELECT param.value.string_value AS file, COUNT(1) AS value
        FROM \`zales-cms-prod.analytics_205854940.events_*\`,
        UNNEST(event_params) AS param
        WHERE event_name = "media_tap" AND param.key = "media_file" `,
    label: "Media File Count",
    headers: [
      { label: "Media File", key: "file" },
      { label: "Total Count", key: "value" },
    ],
    appendquery: ` GROUP BY 1 order by value desc`,
  },
  {
    query: `SELECT param.value.string_value AS file, param2.value.string_value As storename,  COUNT(1) AS value
        FROM \`zales-cms-prod.analytics_205854940.events_*\`,
            UNNEST(event_params) AS param, UNNEST(event_params) AS param2
        WHERE event_name = "media_tap" AND param.key = "media_file" AND param2.key = "STORE_NAME" `,
    label: "Media File Count By Store",
    headers: [
      { label: "Media File", key: "file" },
      { label: "Store Name", key: "storename" },
      { label: "Total Count", key: "value" },
    ],
    appendquery: `group by 1,2 order by value desc`,
  },
];
